<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col cols="12" md="auto" style="width: 250px;">                    
                    <div class="texto-arriba text-center national-bold uppercase bold mx-auto d-none d-md-block" style="text-orientation: mixed; font-size: 55px; white-space: pre;">{{product.displayName}}</div>

                    <span class="d-block d-md-none national-bold uppercase bold mx-auto" style="font-size: 28px;">
                        {{product.displayName}}
                    </span>
                </v-col>
                <v-col cols="12" md="auto" style="max-width: 600px" class="pl-md-12">
                    <span class="national-bold">DETAILS</span>
                    <div class="national-regular" v-html="product.description" style="white-space: pre-line;">

                    </div>
                    <!-- <p class="national-regular" style="white-space: pre-line;">{{product.description}}</p> -->

                    <v-row justify="space-between" align="center">
                        <template v-if="product.hasOwnProperty('designerLogo') && product.designerLogo != null">
                            <v-col cols="auto">
                                <!-- <a :href="product.link" target="_blank">
                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+product.designerLogo.path" max-width="200"></v-img>
                                </a> -->
                                <a :href="product.designerURL" target="_blank">
                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+product.designerLogo.path" max-width="200"></v-img>
                                </a>
                            </v-col>
                        </template>

                        <template v-if="product.otraCosaLink">
                            <v-col cols="auto">
                                <!-- <a href="" target="_blank">
                                    <v-img src="@/assets/img/otracosa.jpg" max-width="200"></v-img>
                                </a> -->

                                <v-btn class="btn-product" color="black" outlined tile :ripple="false" :height="alto" :width="ancho" :href="product.link" target="_blank">
                                    <span class="tag-btn-shop-now">
                                    Shop <span class="bold tag-btn-shop-now"> Now</span>
                                    </span>
                                
                                </v-btn>
                            </v-col>
                        </template>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

        <v-container>
            <v-row>
                <v-col v-if="loaded">
                    <div class="owl-carousel-custom" style="position: relative; overflow: hidden;">
                        <carousel :autoplay="false" :nav="false" :items="2" :dots="false" :responsive="{0:{items:1},600:{items:2}}">
                            <template v-for="(image,img) in product.gallery" >

                                <img :src="'https://artlesscms.actstudio.xyz/'+image.path" :key="'image-'+img">

                            </template>
                            <template slot="prev">
                                <span class="prev-icon"><v-icon size="36" color="#221F1F">mdi-chevron-left</v-icon></span>
                            </template>

                            <template slot="next">
                                <span class="next-icon"><v-icon size="36" color="#221F1F">mdi-chevron-right</v-icon></span>
                            </template>
                        </carousel>   
                    </div>

                    
                </v-col>
            </v-row>

            <template v-if="product != {}">
                <v-row>
                    <v-col class="px-4 py-0">
                        <router-link :to="getBack(product._id)" class="national-light not-text-decoration custom-buttons" style="font-size: 50px;">BACK</router-link>
                    </v-col>
                    <v-col class="px-4 py-0 text-right">
                        <router-link :to="getNext(product._id)" class="national-light not-text-decoration custom-buttons" style="font-size: 50px;">NEXT</router-link>
                    </v-col>
                </v-row>
            </template>
        </v-container>
    </div>
</template>

<script>

import carousel from 'vue-owl-carousel'
export default {
    components: { carousel },
    data(){
        return {
            product: {},
            products: [],
            loaded: false
        }
    },
    computed: {
        alto: function () {
            if (this.$vuetify.breakpoint.width >= 2300) {
                if (this.$vuetify.breakpoint.width >= 3500) {
                return 110;
                } else {
                return 110;
                }
            } else {
                if (this.$vuetify.breakpoint.width >= 2300) {
                return 83;
                } else {
                return 55;
                }
            }
        },
        ancho: function () {
            if (this.$vuetify.breakpoint.width >= 2300) {
                if (this.$vuetify.breakpoint.width >= 2300) {
                return 368;
                } else {
                return 368;
                }
            } else {
                if (this.$vuetify.breakpoint.width >= 3500) {
                return 276;
                } else {
                return 184;
                }
            }
        },
    },
    beforeMount: function() {
        var aux = this;
        fetch(
        "https://www.artlesscms.actstudio.xyz/api/collections/get/CustomProduct?token=a15be93e9cdb43ca2b3778c2077c26",
        {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            filter: {
                url: this.$route.params.url
            },
            populate: 1 // resolve linked collection items
            })
        })
        .then(res => res.json())
        .then(res => (this.product = res.entries[0]))
        .then(res => this.loaded = true)
        .then(()=>{
            var breadcrumbs = [
                // {
                //     text: 'Home',
                //     link: '/',
                //     isLink: true
                // },
                {
                    text: 'Custom',
                    link: '/custom',
                    isLink: true
                },
                {
                    text: this.product.category.name,
                    link: '/custom/category/'+this.product.category.url,
                    isLink: true
                },
                {
                    text: this.product.name,
                    link: '/custom/designers',
                    isLink: true
                }
            ];
            this.$emit("updateStatus", breadcrumbs);
        });


        fetch(
        "https://www.artlesscms.actstudio.xyz/api/collections/get/CustomProduct?token=a15be93e9cdb43ca2b3778c2077c26",
        {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            filter: {
                sort: {},
            },
            populate: 1 // resolve linked collection items
            })
        })
        .then(res => res.json())
        .then(res => (this.products = res.entries))
        .then(function(){
            aux.products.sort(function(a,b){
                if(a.category._o > b.category._o){
                    return 1;
                }
                if(a.category._o < b.category._o){
                    return -1;
                }

                return 0;
            })
        })
    },
    methods: {
        getBack: function(id){
            for (let index = 0; index < this.products.length; index++) {
                if(this.products[index]._id == id){
                    if(index == 0){
                        return '/custom/product/'+this.products[this.products.length - 1].url;
                    }else{
                        return '/custom/product/'+this.products[index - 1].url;
                    }
                }
                
            }
            return '/';
        },
        getNext: function(id){
            for (let index = 0; index < this.products.length; index++) {
                if(this.products[index]._id == id){
                    if(index == this.products.length - 1){
                        return '/custom/product/'+this.products[0].url;
                    }else{
                        return '/custom/product/'+this.products[index + 1].url;
                    }
                }
                
            }
            return '/';
        }
    },
    watch: {
        $route(to, from) {
            var aux = this;
            this.loaded = false;
            fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/CustomProduct?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                filter: {
                    url: this.$route.params.url
                },
                populate: 1 // resolve linked collection items
                })
            })
            .then(res => res.json())
            .then(res => (this.product = res.entries[0]))
            .then(res => aux.loaded = true);
        }
    },
    mounted() {
        this.$emit("update", 2);
        var aux = this;
        gtag('config', 'UA-26953667-1', {
        'page_title' : 'Custom Product '+aux.$route.params.url,
        'page_path': '/custom/product/'+aux.$route.params.url
        });
    },
}
</script>